export default {
  props: {
    disabled: {
      type: Boolean,
      required: false,
      default: () => false
    },
    value: {
      type: Number,
      required: true,
      default: () => 0
    },
    fieldName: {
      type: String,
      required: false,
    },
    maxValue: {
      type: Number,
      required: false,
      default: () => null
    },
    minValue: {
      type: Number,
      default: null,
    }
  },
  data() {
    return {
      localValue: 0
    };
  },
  created() {
    this.localValue = this.value
  },
  computed: {
    computedValue: {
      get: function() {
        return this.localValue;
      },
      set: function(value) {
        this.localValue = value;
      }
    },
    decrementDisabled() {
      return this.disabled || this.localValue === 0 || (this.minValue && this.localValue === this.minValue);
    },
    incrementDisabled() {
      if (this.maxValue === null) {
        return this.disabled;
      } else {
        return this.disabled || this.localValue === this.maxValue;
      }
    }
  },
  watch: {
    selected(value) {
      this.localValue = value;
    },
    value(value) {
      this.localValue = value;
    }
  },
  methods: {
    increment: function() {
      if (this.localValue !== this.maxValue) {
        this.localValue++;
        this.$emit("change", { value: this.localValue, id: this.fieldName});
      }
    },
    decrement: function() {
      if (this.localValue > 0) this.localValue--;
      this.$emit("change", { value: this.localValue, id: this.fieldName});
    }
  }
};
